/**
 * Gets the file extension based on the mime type.
 * @function
 * @name getFileExtension
 * @kind function
 * @param {File} file The intended file.
 * @returns {string} The file extension based on the mime type.
 * @exports
 */
export function getFileExtension(file: File): string {
  const mimeType = file.type;

  switch (mimeType) {
    case "application/pdf":
      return "pdf";
    case "image/jpeg":
      return "jpeg";
    case "image/png":
      return "png";
    default:
      return file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
  }
}
